import { render, staticRenderFns } from "./CustomerCategory.vue?vue&type=template&id=8aa952da&scoped=true"
import script from "./CustomerCategory.vue?vue&type=script&lang=js"
export * from "./CustomerCategory.vue?vue&type=script&lang=js"
import style0 from "./CustomerCategory.vue?vue&type=style&index=0&id=8aa952da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa952da",
  null
  
)

export default component.exports